import { IBook } from '@/pages/Bookstore/types';
import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface IOpenBookContext {
  isReceivedBook: boolean;
  book: IBook | undefined;
  deliveryCode?: string;
  monthReference?: number;
  yearReference?: number;
  openBook: (
    book: IBook,
    receivedBook?: boolean,
    onChangeFavorite?: (favorite: boolean) => void,
    deliveryCode?: string,
    monthReference?: number,
    yearReference?: number
  ) => void;
  closeBook: () => void;
  onChangeFavorite?: (favorite: boolean) => void;
}

const defaultOpenBookContext: IOpenBookContext = {
  book: undefined,
  isReceivedBook: false,
  deliveryCode: undefined,
  monthReference: undefined,
  yearReference: undefined,
  openBook: () => {},
  closeBook: () => {},
  onChangeFavorite: () => {},
};

const OpenBookContext = createContext(defaultOpenBookContext);

const isMobileScreen = () => window.innerWidth < 768;

type OpenBookProviderProps = PropsWithChildren<{ isNative?: boolean }>;

export function OpenBookProvider({ children, isNative }: OpenBookProviderProps) {
  const [data, setData] = useState(defaultOpenBookContext);
  const [isReceivedBook, setIsReceivedBook] = useState(false);

  const shouldPostMessage = isNative || isMobileScreen();

  return (
    <OpenBookContext.Provider
      value={{
        ...data,
        isReceivedBook,
        openBook: (
          book: IBook,
          receivedBook?: boolean,
          onChangeFavorite?: (favorite: boolean) => void,
          deliveryCode?: string,
          monthReference?: number,
          yearReference?: number
        ) => {
          setData({ ...data, book, onChangeFavorite, deliveryCode, monthReference, yearReference });
          setIsReceivedBook(!!receivedBook);
          if (shouldPostMessage) window.parent.postMessage({ type: 'PARTIU_HIDE_CHROME' }, '*');
        },
        closeBook: () => {
          setData({ ...data, book: undefined, deliveryCode: undefined, monthReference: undefined, yearReference: undefined });
          if (shouldPostMessage) {
            setTimeout(() => {
              window.parent.postMessage({ type: 'PARTIU_SHOW_CHROME' }, '*');
            }, 300);
          }
        },
      }}
    >
      {children}
    </OpenBookContext.Provider>
  );
}

export function useOpenBook() {
  return useContext(OpenBookContext);
}
